export type ZipCodeStatus = {
  state: 'valid' | 'invalid' | 'loading' | 'idle';
  hint: string;
};

export const UNKNOWN_ZIP_CODE_LABEL = 'Não sei meu CEP';

export const ZIP_CODE_STATUS = {
  idle: {
    state: 'idle',
    hint: 'Ex: 00000-000',
  },
  invalid: {
    state: 'invalid',
    hint: 'CEP inválido',
  },
  fetching: {
    state: 'loading',
    hint: 'Buscando...',
  },
  error: {
    state: 'invalid',
    hint: 'Erro ao calcular o frete',
  },
  valid: {
    state: 'valid',
    hint: 'CEP válido',
  },
} satisfies Record<string, ZipCodeStatus>;
